import React, { useState } from 'react';

const TestVocacional = ({ onBack }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);

  const questions = [
    {
      question: "¿Qué te gusta más?",
      options: ["Trabajar con números", "Ayudar a otros", "Crear cosas", "Estudiar ciencias", "Organizar eventos"]
    },
    {
      question: "¿Cuál es tu asignatura favorita?",
      options: ["Matemáticas", "Historia", "Arte", "Biología", "Educación Física"]
    },
    {
      question: "¿Qué prefieres hacer en tu tiempo libre?",
      options: ["Leer libros técnicos", "Voluntariado", "Dibujar o diseñar", "Experimentar en el laboratorio", "Deportes"]
    },
    {
      question: "¿Qué carrera te imaginas?",
      options: ["Ingeniería", "Medicina", "Arquitectura", "Psicología", "Derecho"]
    },
    {
      question: "¿Qué te motiva más?",
      options: ["Resolver problemas", "Ayudar a la sociedad", "Innovar", "Descubrir", "Liderar"]
    }
  ];

  const handleAnswer = (answer) => {
    setAnswers([...answers, answer]);
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      // Calcular resultado (ejemplo simple)
      const result = answers.concat(answer).reduce((acc, ans) => acc + ans, 0) % 5;
      const careers = ["Ingeniería", "Medicina", "Arquitectura", "Psicología", "Derecho"];
      alert(`Tu carrera sugerida: ${careers[result]}`);
      onBack(); // Volver al inicio
    }
  };

  return (
    <div className="test-vocacional">
      <h2>Encontrá tu camino en la UNLZ</h2>
      <div className="question">
        <h3>{questions[currentQuestion].question}</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {questions[currentQuestion].options.map((option, index) => (
            <button
              key={index}
              onClick={() => handleAnswer(index)}
              className="py-3 px-6 bg-white border border-slate-200 rounded-lg shadow-sm hover:shadow-md hover:bg-primary-50 hover:border-primary-200 text-slate-700 font-medium transition-all duration-200 transform hover:-translate-y-1 text-left flex items-center"
            >
              <span className="w-6 h-6 rounded-full bg-slate-100 text-slate-500 flex items-center justify-center text-xs mr-3 group-hover:bg-primary-100 group-hover:text-primary-600">
                {String.fromCharCode(65 + index)}
              </span>
              {option}
            </button>
          ))}
        </div>
      </div>
      <button onClick={onBack} className="btn-secondary">Volver</button>
    </div>
  );
};

export default TestVocacional;